import { Filter } from 'lucide-react';
import { useDateFilter } from '~/hooks/useDateFilter';
import { useFunnelData } from '~/hooks/useFunnelData';
import { DateFilterBar } from '~/components/DateFilterBar';
import { FunnelVisualization } from '~/components/FunnelVisualization';
import { LeadSourceTable } from '~/components/LeadSourceTable';
import type { DateFilterPreset } from '~/types';

const FUNNEL_PRESETS: DateFilterPreset[] = ['all', 'today', '7d', '14d', '1m', '3m', '6m'];

export const ConversionFunnel = () => {
  const { preset, setPreset, dateRange } = useDateFilter('all');
  const { loading, stages, leadSources, leadSourceTotal, leadSourcePage, setLeadSourcePage } = useFunnelData(dateRange);

  if (loading && stages.length === 0) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary" />
      </div>
    );
  }

  return (
    <div className="p-6 space-y-8">
      {/* Page header */}
      <div className="flex items-center gap-2">
        <Filter className="h-6 w-6 text-foreground" />
        <h1 className="text-2xl font-bold">Conversion Funnel</h1>
      </div>

      {/* Date filter */}
      <DateFilterBar presets={FUNNEL_PRESETS} value={preset} onChange={setPreset} />

      {/* Funnel visualization */}
      <section>
        <FunnelVisualization stages={stages} />
      </section>

      {/* Lead source analytics */}
      <section>
        <h2 className="text-lg font-semibold mb-4">Lead Source Analytics</h2>
        <LeadSourceTable
          rows={leadSources}
          total={leadSourceTotal}
          page={leadSourcePage}
          onPageChange={setLeadSourcePage}
        />
      </section>
    </div>
  );
};
